// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2jZPM","dragIcon":"SortableItem_dragIcon__1hxeJ","disabled":"SortableItem_disabled__1Zx8W"};